module.exports = __webpack_public_path__ + "img/employer-testimonial-02.889a9511.jpg";